import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsTypefindersService } from './edit-dialogs-typefinders.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-typefinders',
  templateUrl: './edit-dialogs-typefinders.component.html',
  styleUrls: ['./edit-dialogs-typefinders.component.scss']
})
export class EditDialogsTypefindersComponent implements OnInit {

  /** Subscripción para el guardado de un typefinder */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsTypefindersService: EditDialogsTypefindersService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsTypefindersComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsTypefindersService.build(); }

  ngOnInit() {
    this.editDialogsTypefindersService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Typefinder
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsTypefindersService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del typefinder está ausente
      // -1: El número del typefinder ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorTypeFinders('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorTypeFinders('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog fypefinders
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let typefinder = this.editDialogsTypefindersService.typefinders;
    let original = this.editDialogsTypefindersService.originalTypefinders;
    return this.editDialogsTypefindersService.compare(typefinder, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorTypeFinders(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
